<template>
  <div id="thank-you-container" class="ui padded middle aligned centered grid">

    <div class="sixteen wide mobile ten wide tablet eight wide computer column">
      <center>
        <img class="ui image" src="../../public/static/images/social-happy.png">
        <h2 class="ui orange header" style="margin-top: 0em;">Thank you! You're awesome!</h2>
      </center>
      <p>Thank you again for your interest in DermaBuddy! As soon as the beta program is launched, you will be notified by email.</p>

      <p><b>Want to get in even sooner?</b> Gain early access by inviting 1 friend <i class="add user icon"/></p>

      <center>
        <small>Your Unique Link</small>
      </center>
      <div class="ui action fluid input">
        <input
          type="text"
          :value="uniqueLink"
          readonly>
        <button
          class="ui teal right labeled icon button"
          @click="copyToClipboard(uniqueLink)">
          <i class="copy icon"></i>
          Copy
        </button>
      </div>

      <!--TODO: This part needs to be done!-->

      <!--<center>-->
        <!--<br>Share it on your blog, website or social channels:<br>-->
        <!--<div class="ui circular facebook icon button"><i class="facebook icon"/></div>-->
        <!--<div class="ui circular twitter icon button"><i class="twitter icon"/></div>-->
        <!--<div class="ui circular google plus icon button"><i class="envelope icon"/></div>-->
      <!--</center>-->

    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ThankYou',
  data () {
    return {
    }
  },
  computed: {
    uniqueLink() {
      return 'https://dermabuddyapp.com/' + this.$route.params.variant + '?referral=' + this.uniqueCode
    },
    uniqueCode() {
      let strEmail = this.$route.query.email
      var parts = strEmail.split("@")
      var localPart = parts[0].split('+')[0]
      return localPart
    }
  },
  created () {
    switch (this.$route.params.variant.toLowerCase()) {
      case 'symptom-tracker':
        this.updateActiveLandingPage({ activeLandingPage: 'symptomTracker'}).then(()=> {
          this.isLoaded = true;
        })
        break
      case 'crowdsource-community':
        this.updateActiveLandingPage({ activeLandingPage: 'crowdsourceAltruistic'}).then(()=> {
          this.isLoaded = true;
        })
        break
      case 'crowdsource-answers':
        this.updateActiveLandingPage({ activeLandingPage: 'crowdsourceSelfish'}).then(()=> {
          this.isLoaded = true;
        })
        break
      default:
        this.$router.push({ path: '/crowdsource-community' })
        this.updateActiveLandingPage({ activeLandingPage: 'crowdsourceAltruistic'}).then(()=> {
          this.isLoaded = true;
        })
        break
    }

    if (typeof (this.$route.query.email) === 'undefined' || !this.isEmailValid) {
      this.$router.push({ path: '/' + this.$route.params.variant })
    }
  },
  methods: {
    ...mapActions(['updateActiveLandingPage']),
    isEmailValid(email) {
      // Reference: https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
      var re = /\S+@\S+\.\S+/;
      return re.test(email);
    },
    copyToClipboard(str) {
      // Reference: https://hackernoon.com/copying-text-to-clipboard-with-javascript-df4d4988697f
      const el = document.createElement('textarea');  // Create a <textarea> element
      el.value = str;                                 // Set its value to the string that you want copied
      el.setAttribute('readonly', '');                // Make it readonly to be tamper-proof
      el.style.position = 'absolute';
      el.style.left = '-9999px';                      // Move outside the screen to make it invisible
      document.body.appendChild(el);                  // Append the <textarea> element to the HTML document
      const selected =
        document.getSelection().rangeCount > 0        // Check if there is any content selected previously
          ? document.getSelection().getRangeAt(0)     // Store selection if found
          : false;                                    // Mark as false to know no selection existed before
      el.select();                                    // Select the <textarea> content
      document.execCommand('copy');                   // Copy - only works as a result of a user action (e.g. click events)
      document.body.removeChild(el);                  // Remove the <textarea> element
      if (selected) {                                 // If a selection existed before copying
        document.getSelection().removeAllRanges();    // Unselect everything on the HTML document
        document.getSelection().addRange(selected);   // Restore the original selection
      }
    }
  }
}
</script>

<style scoped>
#thank-you-container {
  width: 100vw;
  min-height: 100vh;
}
</style>
